import { render, staticRenderFns } from "./Yellow.vue?vue&type=template&id=e1efdcc4&"
import script from "./Yellow.vue?vue&type=script&lang=js&"
export * from "./Yellow.vue?vue&type=script&lang=js&"
import style0 from "./Yellow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports